import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import uuid from 'uuid/v4';
import profileIcon from '../../../images/insight360/360-generic-profile-icon.png';
import profileIconHappy from '../../../images/insight360/360-profile-icon_happy-life.png';
import profileIconInternational from '../../../images/insight360/360-profile-icon_international.png';
import profileIconMoney from '../../../images/insight360/360-profile-icon_MONEY.png';
import profileIconOptimist from '../../../images/insight360/360-profile-icon_optimist.png';
import profileIconPerfectionist from '../../../images/insight360/360-profile-icon_perfectionist.png';
import profileIconRiskTaker from '../../../images/insight360/360-profile-icon_risk-taker.png';
import profileIconStandOut from '../../../images/insight360/360-profile-icon_stand-out.png';
import profileIconWorkaholic from '../../../images/insight360/360-profile-icon_workaholic.png';
import profileIconWorry from '../../../images/insight360/360-profile-icon_worry.png';
import profileIconAlone from '../../../images/insight360/360-profile-icon_alone.png';
import profileIconArts from '../../../images/insight360/360-profile-icon_arts.png';
import profileIconCrime from '../../../images/insight360/360-profile-icon_crime.png';
import profileIconFamily from '../../../images/insight360/360-profile-icon_family.png';
import ProfilesSinglePersonality from './ProfilesSinglePersonality';
import ProfilesSingleTops from './ProfilesSingleTops';
import ProfilesOutlookDetails from './ProfilesOutlookDetails';
import { getStartIndex } from '../../../util/Insight360Utils';

// MRI Icons
import profileIconSocialStatus from '../../../images/insight360/360-profile-icon_social-status.png';
import profileIconEnvironmentalist from '../../../images/insight360/360-profile-icon_environmentalist.png';
import profileIconSophisticated from '../../../images/insight360/360-profile-icon_sophisticated.png';
import profileIconFun from '../../../images/insight360/360-profile-icon_fun.png';
import profileIconSpiritual from '../../../images/insight360/360-profile-icon_spiritual.png';
import profileIconFriends from '../../../images/insight360/360-profile-icon_friends.png';
import profileIconSocial from '../../../images/insight360/360-profile-icon_social.png';
import profileIconMetime from '../../../images/insight360/360-profile-icon_me-time.png';
import profileIconOutspoken from '../../../images/insight360/360-profile-icon_outspoken.png';


const iconComponents = [
  { id: '360GenericProfileIcon', selectedIcon: profileIcon },
  { id: '360ProfileIconHappyLife', selectedIcon: profileIconHappy },
  { id: '360ProfileIconInternational', selectedIcon: profileIconInternational },
  { id: '360ProfileIconMoney', selectedIcon: profileIconMoney },
  { id: '360ProfileIconOptimist', selectedIcon: profileIconOptimist },
  { id: '360ProfileIconPerfectionist', selectedIcon: profileIconPerfectionist },
  { id: '360ProfileIconRiskTaker', selectedIcon: profileIconRiskTaker },
  { id: '360ProfileIconStandOut', selectedIcon: profileIconStandOut },
  { id: '360ProfileIconWorkaholic', selectedIcon: profileIconWorkaholic },
  { id: '360ProfileIconWorry', selectedIcon: profileIconWorry },
  { id: '360ProfileIconAlone', selectedIcon: profileIconAlone },
  { id: '360ProfileIconArts', selectedIcon: profileIconArts },
  { id: '360ProfileIconCrime', selectedIcon: profileIconCrime },
  { id: '360ProfileIconFamily', selectedIcon: profileIconFamily },
  { id: '360ProfileIconSocialStatus', selectedIcon: profileIconSocialStatus },
  { id: '360ProfileIconFun', selectedIcon: profileIconFun },
  { id: '360ProfileIconEnvironmentalist', selectedIcon: profileIconEnvironmentalist },
  { id: '360ProfileIconSpiritual', selectedIcon: profileIconSpiritual },
  { id: '360ProfileIconFriends', selectedIcon: profileIconFriends },
  { id: '360ProfileIconSocial', selectedIcon: profileIconSocial },
  { id: '360ProfileIconMetime', selectedIcon: profileIconMetime },
  { id: '360ProfileIconOutspoken', selectedIcon: profileIconOutspoken },
  { id: '360ProfileIconSophisticated', selectedIcon: profileIconSophisticated },
];

class ProfilesSinglePersona extends Component {

  getImageIcon = imageKey => {
    const imageComponent = _.find(iconComponents, { id: imageKey });
    if (imageComponent !== undefined) {
      return imageComponent.selectedIcon;
    }
    return undefined;
  }

  render() {
    return (
      <div className="row fullwidth" id="profilePersonaFirstSection">
        <div className="large-1 medium-1 small-1 columns">
          <span>&nbsp;</span>
        </div>
        <div className="large-10 medium-10 small-10 columns" id="downloadPdf">
          {this.props.profile !== undefined && (
            <div>
              <div
                className="row demographic-detail-columns fullwidth"
                id="pdfProfileGrid"
              >
                <div className="columns large-4 small-4 medium-4">
                  <img
                    src={
                        Object.entries(this.props.profile)[0][1].value.icon === undefined
                          ? this.getImageIcon(
                            _.camelCase(
                              '360-generic-profile-icon.png'.replace(
                                '.png',
                                '',
                              ),
                            ),
                          )
                          : this.getImageIcon(
                            _.camelCase(
                              Object.entries(this.props.profile)[0][1].value.icon.replace(
                                '.png',
                                '',
                              ),
                            ),
                          )
                      }
                    className="i360-profile-persona-img"
                    alt="Profile Icon"
                  />
                </div>
                <div className="columns large-8 small-8 medium-8">
                  <ProfilesSinglePersonality personality={Object.entries(this.props.profile)} />
                  <div className="row">
                    {Object.entries(this.props.profile).slice(
                    getStartIndex(this.props.profile)).map(item => (
                      <div
                        key={uuid()}
                        className="columns large-6 small-6 medium-6 profile-single-left-col profile-float-left"
                      >
                        <ProfilesOutlookDetails
                          outlookHeading={item[0]}
                          outlookDetail={item[1]}
                        />
                      </div>
                ))}
                  </div>

                  <div className="row demographic-detail-columns fullwidth" />
                </div>
              </div>
              <ProfilesSingleTops index={0} insight360studyInfo={this.props.insight360studyInfo} brands={this.props.brands} />
              <ProfilesSingleTops index={1} insight360studyInfo={this.props.insight360studyInfo} brands={this.props.media} /> 
            </div>
          )}
        </div>
        <div className="large-1 medium-1 small-1 columns">
          <span>&nbsp;</span>
        </div>
      </div>
    );
  }

}

ProfilesSinglePersona.propTypes = {
  profile: PropTypes.shape({}),
  brands: PropTypes.shape({}),
  media: PropTypes.shape({}),
};

export default connect(
  null,
  null,
  null,
  { forwardRef: true },
)(ProfilesSinglePersona);
